/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountData
 */
export interface AccountData {
    /**
     * Name des Benutzers
     * @type {string}
     * @memberof AccountData
     */
    name: string;
    /**
     * E-Mail-Adresse
     * @type {string}
     * @memberof AccountData
     */
    email: string;
    /**
     * Unternehmensname
     * @type {string}
     * @memberof AccountData
     */
    company: string;
    /**
     * Aktueller Plan
     * @type {string}
     * @memberof AccountData
     */
    plan: AccountDataPlanEnum;
    /**
     * Monatliches Kontingent
     * @type {number}
     * @memberof AccountData
     */
    monthlyLimit: number;
    /**
     * Bereits verwendete Steine
     * @type {number}
     * @memberof AccountData
     */
    usedBricks: number;
    /**
     * Datum des nächsten Resets
     * @type {Date}
     * @memberof AccountData
     */
    resetDate: Date;
}


/**
 * @export
 */
export const AccountDataPlanEnum = {
    Free: 'free',
    Premium: 'premium',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type AccountDataPlanEnum = typeof AccountDataPlanEnum[keyof typeof AccountDataPlanEnum];


/**
 * Check if a given object implements the AccountData interface.
 */
export function instanceOfAccountData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "plan" in value;
    isInstance = isInstance && "monthlyLimit" in value;
    isInstance = isInstance && "usedBricks" in value;
    isInstance = isInstance && "resetDate" in value;

    return isInstance;
}

export function AccountDataFromJSON(json: any): AccountData {
    return AccountDataFromJSONTyped(json, false);
}

export function AccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'company': json['company'],
        'plan': json['plan'],
        'monthlyLimit': json['monthlyLimit'],
        'usedBricks': json['usedBricks'],
        'resetDate': (new Date(json['resetDate'])),
    };
}

export function AccountDataToJSON(value?: AccountData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'company': value.company,
        'plan': value.plan,
        'monthlyLimit': value.monthlyLimit,
        'usedBricks': value.usedBricks,
        'resetDate': (value.resetDate.toISOString()),
    };
}

